import axios from 'axios';
import { LanguageObject } from '@/i18n';
import { OversightOrganization } from './OversightUtils';
import  {Survey} from './SurveyUtils';
import  {User} from './UserUtils';

interface stateSummary {
  users: Partial<User>;
  surveys:Partial<Survey>;
}

interface ServiceProviderType {
  id?: number;
  name: LanguageObject;
}

interface ServiceProvider {
  id?: number;
  name: LanguageObject;
  state: String;
  serviceprovidertype: Partial<ServiceProviderType>;
  parent: Partial<OversightOrganization>[];
}

const api = {
  instance: {
    list: async (params?: { showinactive: boolean }) => {
      const resp = await axios.get<ServiceProvider[]>(
        '/serviceProvider/list.php', {
          params: params,
         } );
      return resp.data;
    },

    changeState: async (params?: { persist: boolean ,id:number, state:string}) => {
      const resp = await axios.get<stateSummary>(
        '/serviceProvider/switchState.php', {
          params: params,
         } );
      return resp.data;
    },

    get: async (id: number) => {
      const resp = await axios.get<ServiceProvider>(
        '/serviceProvider/get.php',
        {
          params: { id: id },
        }
      );
      return resp.data;
    },

    add: async (provider: ServiceProvider) => {
      const resp = await axios.post<{ id: number }>(
        '/serviceProvider/add.php',
        provider
      );
      return resp.data.id;
    },

    update: async (provider: Partial<ServiceProvider>) => {
      await axios.post('/serviceProvider/update.php', provider);
    },

    remove: async (id: number) => {
      await axios.delete('/serviceProvider/delete.php', {
        params: { id: id },
      });
    },
  },
  type: {
    list: async () => {
      const resp = await axios.get<ServiceProviderType[]>(
        '/serviceProviderType/list.php'
      );
      return resp.data;
    },

    get: async (id: number) => {
      const resp = await axios.get<ServiceProviderType>(
        '/serviceProviderType/get.php',
        {
          params: { id: id },
        }
      );
      return resp.data;
    },

    add: async (type: ServiceProviderType) => {
      const resp = await axios.post<{ id: number }>(
        '/serviceProviderType/add.php',
        type
      );
      return resp.data.id;
    },

    update: async (type: Partial<ServiceProviderType>) => {
      await axios.post('/serviceProviderType/update.php', type);
    },

    remove: async (id: number) => {
      await axios.delete('/serviceProviderType/delete.php', {
        params: { id: id },
      });
    },
  },
};

export default {
  api,
};

export { ServiceProvider, ServiceProviderType,stateSummary };
